import Vue from 'vue'
import Vuex from 'vuex'
import VueAxios from 'vue-axios'
import { VueAuthenticate } from 'vue-authenticate'
import axios from 'axios';
import axiosclient from '../../utils/axiosclient';

Vue.use(Vuex)
Vue.use(VueAxios, axios)


const ENDPOINT_BASE="/api/v1"
const ENDPOINT_USER_AUTHENTICATE="/v1/oauth/token"
const ENDPOINT_USER_INFO= "/v1/me"
const ENDPOINT_USER= "/v2/users"
const ENDPOINT_USER_REGISTER= "/v1/users"
const ENDPOINT_USER_VERIFY= "/v1/user/verify"
const ENDPOINT_USER_FORGET= "/v1/user/forget"
const ENDPOINT_USER_CHANGE_PASS= "/v1/users/change-password"

const state = {
    profile: null,
    registrationData: null,
    forgetData: null,
    banners:[]

}

const getters = {}

const mutations = {
    setProfile: (state, payload) => {
        state.profile = payload
    },

    setRegistrationData: (state, payload) => {
        state.registrationData = payload
    },

    setForgetData: (state, payload) => {
        state.forgetData = payload
    },

    setBanners: (state, payload) => {
        state.banners = payload
    }
}

const actions = {
    performLoginPassword({commit}, payload) {
        //console.log(username, password)
        const clientId = process.env.VUE_APP_CLIENT_ID
        const clientSecret = process.env.VUE_APP_CLIENT_SECRET
        return axiosclient.post(ENDPOINT_USER_AUTHENTICATE, {username: payload.username, password:payload.password, grant_type:'password', client_id: clientId, client_secret: clientSecret}).then(res => {
            const session = res.data
            commit('setAccessToken', session.access_token)
            return Promise.resolve(res.data)
            
        }).catch(err => {

            return Promise.reject("Authentication Error") 
        })
    },
    fetchUserInfoAction({commit}, payload) {
        commit('setLoading', true, {root: true})
        return axiosclient.get(ENDPOINT_USER_INFO).then(res => {
            let ganttView = res.data.user_preference.filter(p => p.key == 'GANTT_VIEW_MODE') 
            if(ganttView.length>0) {
                res.data.ganttViewMode = ganttView[0].value
            } else {
                res.data.ganttViewMode = "day"
            }    
            let ganttDay = res.data.user_preference.filter(p => p.key == 'GANTT_DAY_MODE') 
            if(ganttDay.length>0) {
                res.data.ganttDayMode = ganttDay[0].value
            } else {
                res.data.ganttDayMode = "full-week"
            }
            let ganttComment = res.data.user_preference.filter(p => p.key == 'GANTT_COMMENT_MODE') 
            if(ganttComment.length>0) {
                res.data.ganttCommentMode = ganttComment[0].value
            } else {
                res.data.ganttCommentMode = "task-title"
            }

            let ganttZoom= res.data.user_preference.filter(p => p.key == 'GANTT_ZOOM_MODE') 
            if(ganttZoom.length>0) {
                res.data.ganttZoomMode = ganttZoom[0].value
            } else {
                res.data.ganttZoomMode = "few"
            }

            let showFinance = res.data.user_preference.filter(p => p.key == 'SHOW_FINANCE') 
            if(showFinance.length>0) {
                res.data.showFinance = showFinance[0].value
            } else {
                res.data.showFinance = "0" //default
            }
            res.data.showFinance = "1";

            let quoteCalculationInterval = res.data.user_preference.filter(p => p.key == 'QUOTE_CALCULATION_INTERVAL') 
            if(quoteCalculationInterval.length>0) {
                res.data.quoteCalculationInterval = quoteCalculationInterval[0].value
            } else {
                res.data.quoteCalculationInterval = "HOUR" //default
            }
            res.data.showFinance = "1";

            let demoProject = res.data.user_preference.filter(p => p.key == 'DEMO_PROJECT') 
            if(demoProject.length>0) {
                res.data.demoProject = demoProject[0].value
            } else {
                res.data.demoProject = "0"
            }

            let pref = res.data.user_preference.filter(p => p.key == 'CURRENCY') 
            if(pref.length>0) {
                res.data.currency = JSON.parse(pref[0].value)
            } else {
                res.data.currency = {value: 'AUD', label: 'Australia', symbol:'$'}
            }

            commit('setLoading', false, {root: true})
            commit('setProfile', res.data)
            return Promise.resolve(res.data)
        }).catch(err => {
            commit('setLoading', false, {root: true})
            return Promise.reject(err)
        })
    },
    performUserRegistration({commit}, payload) {
        return axiosclient.post(ENDPOINT_USER_REGISTER, payload).then(res => {
            return Promise.resolve(res.data)
        }).catch(err => {

            return Promise.reject(err) 
        })
    },

    completeRegistration({commit}, payload) {
        return axiosclient.put('/v1/users/update-invitation', payload).then(res => {
            return Promise.resolve(res.data)
        }).catch(err => {

            return Promise.reject(err) 
        })
    },

    fetchAllUsers({commit}, payload) {
        return axiosclient.get(ENDPOINT_USER+'/search?q='+payload).then(res => {
            return Promise.resolve(res.data)
        }).catch(err => {

            return Promise.reject(err) 
        })
    },


  

    performUserVerification({commit}, payload) {
        return axiosclient.post(ENDPOINT_USER_VERIFY, payload).then(res => {
            return Promise.resolve(res.data)
        }).catch(err => {

            return Promise.reject(err) 
        })
    },

    async performPasswordReset({commit}, payload) {
        try {
            const res = await axiosclient.post(ENDPOINT_USER_FORGET, payload);
            commit('setForgetData', res.data);
            return Promise.resolve(res.data);
        }
        catch (err) {
            return Promise.reject(err);
        }
    },

    async inviteClient({commit}, payload) {
        try {
            const res = await axiosclient.post('/v1/client/invite', payload);
            return Promise.resolve(res.data);
        }
        catch (err) {
            return Promise.reject(err);
        }
    },

    async inviteUser({commit}, payload) {
        try {
            const res = await axiosclient.post('/v1/user/invite', payload);
            return Promise.resolve(res.data);
        }
        catch (err) {
            return Promise.reject(err);
        }
    },
    

    async completePasswordReset({commit}, payload) {
        try {
            const res = await axiosclient.post(ENDPOINT_USER_CHANGE_PASS, payload);
            return Promise.resolve(res.data);
        }
        catch (err) {
            return Promise.reject(err);
        }
    },

    async savePreference({commit}, payload) {
        try {
            const res = await axiosclient.post('/v1/user-preference', payload);
            return Promise.resolve(res.data);
        }
        catch (err) {
            return Promise.reject(err);
        }
    },

    async connectStripe({commit}, payload) {
        return axiosclient.post('/merchants/connect_stripe', payload).then(res => {
            return Promise.resolve(res.data)
        }).catch(err => {
            return Promise.reject(err) 
        })
    },

    async checkoutStripe({commit}, payload) {
        return axiosclient.post('/merchants/checkout', payload).then(res => {
            return Promise.resolve(res.data)
        }).catch(err => {
            return Promise.reject(err) 
        })
    },

    getDemoLogin({commit}, payload) {
        return axiosclient.get('/v1/login-credentials?auth-token='+payload).then(res => {
            return Promise.resolve(res.data)
        }).catch(err => {

            return Promise.reject(err) 
        })
    },

    updateProfileInfo({commit}, payload) {
        return axiosclient.put(ENDPOINT_USER_INFO, payload).then(res => {
            return Promise.resolve(res.data)
        }).catch(err => {
            return Promise.reject(err) 
        })
    },

    deleteBanner({commit}, payload) {
        return axiosclient.delete('/v1/banners/'+payload).then(res => {
            return Promise.resolve(res.data)
        }).catch(err => {

            return Promise.reject(err) 
        })
    },
    saveBanner({commit}, payload) {
        return axiosclient.post('/v1/banners', payload).then(res => {
            return Promise.resolve(res.data)
        }).catch(err => {

            return Promise.reject(err) 
        })
    },

    fetchBanners({commit}) {
        return axiosclient.get('/v1/banners').then(res => {
            commit('setBanners', res.data.data)
            return Promise.resolve(res.data)
        }).catch(err => {

            return Promise.reject(err) 
        })
    },

    fetchAllLogs({commit}, payload) {
        return axiosclient.get('/activity/logs').then(res => {
            return Promise.resolve(res.data.data)
        }).catch(err => {

            return Promise.reject(err) 
        })
    },



    
}

export default {
namespaced: true,
state,
getters,
mutations,
actions
}